<script setup>
import 'swiper/css';

import { Swiper, SwiperSlide } from 'swiper/vue';

const props = defineProps({
  initialSlide: {
    type: Number,
    default: 0
  }
})

const swiperInstance = ref(null)
const onSwiper = (swiper) => {
  swiperInstance.value = swiper
}

const mounted = ref(false)

onMounted(() => {
  mounted.value = true
})

defineExpose({
  swiperInstance
})
</script>

<style module>
.root:not([data-ready]) {
  visibility: hidden;
}

.root :global(.swiper) {
  cursor: pointer;
}

.root :global(.swiper-wrapper) {
  transition-property: transform !important;
}
</style>

<template>
  <div
    :class="$style.root"
    :data-ready="mounted ? '' : null"
  >
    <swiper
      :slides-per-view="'auto'"
      :centered-slides="true"
      :allow-touch-move="true"
      :initial-slide="initialSlide"
      :space-between="40"
      :speed='250'
      @swiper="onSwiper"
      @slideChangeTransitionEnd="$emit('slideChange')"
    >
      <slot />
    </swiper>
  </div>
</template>
